"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkStyles = void 0;
const lit_1 = require("lit");
const shared_styles_1 = require("@/stylesheets/shared.styles");
exports.linkStyles = (0, lit_1.css) `
  :host {
    --link-text-color: var(--primary-color);
    --link-gap: var(--space-1);
  }

  .link {
    display: inline-flex;
    align-items: center;
    gap: var(--link-gap);
    border-radius: var(--radius);
    text-decoration: underline;
    text-decoration-skip-ink: auto;
    line-height: inherit;
    color: var(--link-text-color);
  }

  .link:focus-visible {
    ${shared_styles_1.focusRingStyles};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGluay5zdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJsaW5rLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBeUI7QUFFekIsK0RBQTZEO0FBRWhELFFBQUEsVUFBVSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7TUFrQnZCLCtCQUFlOztDQUVwQixDQUFBIn0=